// L'ALPHABET DE BAUHAUS : des capitales géométriques sans empattement
// construites en traits droits et en arcs (pas de police système : le même
// dessin sur le Pi, la TV et le navigateur), et leur atlas de champs de
// distance EXACTS calculé une fois (sans canvas : testable sous Node).
//
// Unités du dessin : hauteur de capitale = 1, y vers le haut, graisse 0,19.
// l x1 y1 x2 y2 : trait à bouts carrés ; a cx cy r a0 a1 : arc (degrés, sens
// direct) à bouts francs ; c cx cy r : anneau. Le tout est rogné à la boîte
// [0, largeur] x [0, 1] : les diagonales y prennent des bouts plats (A, V, M).

const WT = 0.19, H = WT / 2;
const G = {
  A: [0.80, 'l .095 -.2 .40 1.2 | l .40 1.2 .705 -.2 | l .2 .3 .6 .3'],
  B: [0.72, 'l .095 0 .095 1 | l .095 .905 .42 .905 | l .095 .55 .42 .55 | l .095 .095 .40 .095 | a .42 .7275 .1775 -90 90 | a .40 .3225 .2275 -90 90'],
  C: [0.96, 'a .5 .5 .405 45 315'],
  D: [0.80, 'l .095 0 .095 1 | l .095 .905 .30 .905 | l .095 .095 .30 .095 | a .30 .5 .405 -90 90'],
  E: [0.60, 'l .095 0 .095 1 | l .095 .905 .60 .905 | l .095 .5 .52 .5 | l .095 .095 .60 .095'],
  F: [0.58, 'l .095 0 .095 1 | l .095 .905 .58 .905 | l .095 .5 .50 .5'],
  G: [1.00, 'a .5 .5 .405 40 360 | l .55 .5 .905 .5'],
  H: [0.74, 'l .095 0 .095 1 | l .645 0 .645 1 | l .095 .5 .645 .5'],
  I: [0.19, 'l .095 0 .095 1'],
  J: [0.62, 'l .525 1 .525 .3 | a .30 .3 .225 180 360'],
  K: [0.72, 'l .095 0 .095 1 | l .095 .40 .78 1.1 | l .32 .60 .78 -.1'],
  L: [0.56, 'l .095 0 .095 1 | l .095 .095 .56 .095'],
  M: [0.92, 'l .095 0 .095 1 | l .825 0 .825 1 | l .095 1 .46 .25 | l .46 .25 .825 1'],
  N: [0.78, 'l .095 0 .095 1 | l .685 0 .685 1 | l .095 1 .685 0'],
  O: [1.00, 'c .5 .5 .405'],
  P: [0.72, 'l .095 0 .095 1 | l .095 .905 .40 .905 | l .095 .45 .40 .45 | a .40 .6775 .2275 -90 90'],
  Q: [1.00, 'c .5 .5 .405 | l .60 .32 1.0 -.1'],
  R: [0.74, 'l .095 0 .095 1 | l .095 .905 .40 .905 | l .095 .45 .40 .45 | a .40 .6775 .2275 -90 90 | l .38 .45 .74 -.15'],
  S: [0.64, 'a .33 .7025 .2025 90 270 | a .33 .2975 .2025 -90 90 | l .33 .905 .64 .905 | l 0 .095 .33 .095'],
  T: [0.74, 'l 0 .905 .74 .905 | l .37 0 .37 1'],
  U: [0.78, 'l .095 1 .095 .39 | l .685 1 .685 .39 | a .39 .39 .295 180 360'],
  V: [0.80, 'l .095 1.2 .40 -.2 | l .40 -.2 .705 1.2'],
  W: [1.12, 'l .095 1.2 .32 -.2 | l .32 -.2 .56 .75 | l .56 .75 .80 -.2 | l .80 -.2 1.025 1.2'],
  X: [0.76, 'l .095 1 .665 0 | l .095 0 .665 1'],
  Y: [0.76, 'l .095 1.05 .38 .45 | l .665 1.05 .38 .45 | l .38 .45 .38 0'],
  Z: [0.66, 'l 0 .905 .66 .905 | l .60 .905 .06 .095 | l 0 .095 .66 .095'],
  0: [0.76, 'l .095 .3 .095 .7 | l .665 .3 .665 .7 | a .38 .7 .285 0 180 | a .38 .3 .285 180 360'],
  1: [0.42, 'l .32 0 .32 1 | l .32 .95 .02 .74'],
  2: [0.68, 'a .34 .66 .245 -40 180 | l .53 .50 .06 .03 | l .095 .095 .68 .095'],
  3: [0.64, 'a .32 .7025 .2025 -90 160 | a .32 .2975 .2025 -160 90'],
  4: [0.74, 'l .55 0 .55 1 | l .55 1 .06 .30 | l .095 .32 .74 .32'],
  5: [0.66, 'l .62 .905 .095 .905 | l .095 .905 .095 .52 | a .33 .30 .235 -150 110 | l .095 .52 .26 .52'],
  6: [0.72, 'c .36 .36 .265 | l .17 .47 .50 1.02'],
  7: [0.66, 'l 0 .905 .66 .905 | l .60 .905 .20 -.05'],
  8: [0.66, 'c .33 .7275 .1775 | c .33 .2975 .2025'],
  9: [0.72, 'c .36 .64 .265 | l .55 .53 .22 -.02'],
  '-': [0.50, 'l 0 .45 .5 .45'],
  '.': [0.19, 'l .095 0 .095 .19'],
  "'": [0.19, 'l .095 .7 .095 1'],
  '!': [0.19, 'l .095 .32 .095 1 | l .095 0 .095 .19'],
  '?': [0.62, 'a .31 .70 .215 -60 180 | l .42 .52 .31 .40 | l .31 .42 .31 .30 | l .31 0 .31 .19'],
  '&': [0.80, 'c .30 .74 .17 | l .22 .58 .76 -.05 | a .30 .27 .19 90 330 | l .46 .17 .76 .45']
};
export const GLYPH_CHARS = Object.keys(G);
export const SPACE = 0.36, TRACK = 0.12;

function parse(str) {
  return str.split('|').map((t) => { const a = t.trim().split(/\s+/); return [a[0]].concat(a.slice(1).map(Number)); });
}
const PARSED = {};
for (const k of GLYPH_CHARS) PARSED[k] = { w: G[k][0], prims: parse(G[k][1]) };

export function glyphWidth(ch) { return PARSED[ch] ? PARSED[ch].w : 0; }

// la distance signée (unités de capitale) au glyphe, < 0 dedans
export function glyphSdf(ch, x, y) {
  const g = PARSED[ch];
  if (!g) return 1;
  let d = 1e9;
  for (const p of g.prims) {
    let e;
    if (p[0] === 'l') {
      const [, x1, y1, x2, y2] = p;
      const dx = x2 - x1, dy = y2 - y1, L = Math.hypot(dx, dy), ux = dx / L, uy = dy / L;
      const px = x - (x1 + x2) / 2, py = y - (y1 + y2) / 2;
      const a = Math.abs(px * ux + py * uy) - (L / 2 + H), b = Math.abs(-px * uy + py * ux) - H;   // bouts carrés
      e = Math.hypot(Math.max(a, 0), Math.max(b, 0)) + Math.min(Math.max(a, b), 0);
    } else if (p[0] === 'c') {
      e = Math.abs(Math.hypot(x - p[1], y - p[2]) - p[3]) - H;
    } else {
      const [, cx, cy, r, a0, a1] = p;
      let ang = Math.atan2(y - cy, x - cx) * 180 / Math.PI;
      while (ang < a0) ang += 360; while (ang > a0 + 360) ang -= 360;
      if (ang <= a1) e = Math.abs(Math.hypot(x - cx, y - cy) - r) - H;
      else {
        // hors de l'arc : la distance aux deux bouts francs (segments radiaux)
        e = 1e9;
        for (const t of [a0, a1]) {
          const c = Math.cos(t * Math.PI / 180), s = Math.sin(t * Math.PI / 180);
          const qx = x - cx, qy = y - cy;
          const along = qx * c + qy * s, across = -qx * s + qy * c;
          const ra = Math.abs(along - r) - H;
          e = Math.min(e, Math.hypot(Math.max(ra, 0), across) + (ra < 0 ? 0 : 0));
        }
      }
    }
    d = Math.min(d, e);
  }
  // rogné à la boîte du glyphe
  const bx = Math.max(-x, x - g.w), by = Math.max(-y, y - 1);
  return Math.max(d, bx, by);
}

// L'ATLAS : CELL x CELL px par glyphe, capitale de CAP px, marge de champ SPREAD px
export const ATLAS = { CELL: 64, CAP: 40, SPREAD: 8, COLS: 8 };
export function glyphCell(ch) {
  const i = GLYPH_CHARS.indexOf(ch);
  return i < 0 ? null : { cx: i % ATLAS.COLS, cy: Math.floor(i / ATLAS.COLS), w: PARSED[ch].w };
}
export function atlasSize() { return [ATLAS.CELL * ATLAS.COLS, ATLAS.CELL * Math.ceil(GLYPH_CHARS.length / ATLAS.COLS)]; }
// le glyphe est posé dans sa case : origine (bas gauche de la capitale) à (MARGIN, MARGIN)
export const MARGIN = (ATLAS.CELL - ATLAS.CAP) / 2;
let _atlas = null;
export function buildAtlas() {
  if (_atlas) return _atlas;
  const [W, Hh] = atlasSize();
  const data = new Uint8Array(W * Hh * 4);
  const { CELL, CAP, SPREAD } = ATLAS;
  GLYPH_CHARS.forEach((ch, i) => {
    const ox = (i % ATLAS.COLS) * CELL, oy = Math.floor(i / ATLAS.COLS) * CELL;
    const mx = (CELL - PARSED[ch].w * CAP) / 2;            // centré horizontalement dans sa case
    for (let j = 0; j < CELL; j++) for (let k = 0; k < CELL; k++) {
      const gx = (k + 0.5 - mx) / CAP, gy = (j + 0.5 - MARGIN) / CAP;
      const d = glyphSdf(ch, gx, gy) * CAP;               // en px d'atlas
      const v = Math.round(Math.max(0, Math.min(1, 0.5 - d / (2 * SPREAD))) * 255);
      const o = ((oy + j) * W + ox + k) * 4;
      data[o] = data[o + 1] = data[o + 2] = v; data[o + 3] = 255;
    }
  });
  _atlas = { data, width: W, height: Hh };
  return _atlas;
}

// texte -> caractères connus (accents retirés, capitales)
export function normaliseText(s) {
  return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase()
    .replace(/Œ/g, 'OE').replace(/Æ/g, 'AE').replace(/ß/g, 'SS')
    .split('').filter((c) => c === ' ' || PARSED[c]).join('').replace(/\s+/g, ' ').trim();
}
